module.exports = __webpack_public_path__ + "img/Blumenkind.882c4bb3.jpg";